import Vue from 'vue'
import { showNotification } from '@/services/calculate'
import { socketEvents, checkEvents } from '@/services/config'
import { formatCurrency } from '@/services/convert'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import EstimateTakeoff from '@/components/DynamicComponents/Projects/NewConstruction/EstimateTakeoff'
import EstimateGroup from '@/components/DynamicComponents/Projects/NewConstruction/EstimateGroups'
import EstimateGroups from '@/components/DynamicComponents/Projects/EstimateGroups'

export default {
  props: [
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'projectModule',
    'child',
  ],
  components: {
    'estimate-takeoff': EstimateTakeoff,
    'estimate-group': EstimateGroup,
    'estimate-groups': EstimateGroups,
  },
  data() {
    return {
      columnDefs: [],
      loader: false,
      create: new Vue(),
      formatCurrency: formatCurrency,
      list: [],
      panels: [],
      activeKey: 0,
      activeTab: 0,
      visible: false,
      estimateMethod: undefined,
      isDelete: false,
      isArchive: false,
    }
  },
  beforeMount() {
    this.isArchive = _.get(this.projectData, 'isArchive', false)
    this.loadingConfig()
  },
  created() {
    this.$socketHub.$on('message-received', this.recievedMessage)
    this.getEstimates()
  },
  mounted() {
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          filter: false,
          editable: false,
          width: 5,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          hide: true,
        },
        {
          headerName: 'Cost Type',
          field: 'costType',
          headerTooltip: 'Cost Type',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            searchType: 'string',
          },
          width: 120,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          headerTooltip: 'Cat Code',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'takeoff',
          headerTooltip: 'Description',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 300,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Cost',
          field: 'unitCost',
          headerTooltip: 'Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: {
            searchType: 'string',
          },
          headerClass: 'header-right',
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
        },
        {
          headerName: 'ID',
          field: 'id',
          headerTooltip: 'ID',
          width: 60,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          cellRendererParams: {
            searchType: 'string',
          },
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellStyle: { textAlign: 'left' },
          headerClass: 'header-left',
        },
        {
          headerName: 'Tile Name',
          field: 'tileName',
          headerTooltip: 'Tile Name',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
        },
        {
          headerName: 'Estimate Method',
          field: 'estimatedMethod',
          headerTooltip: 'Estimate Method',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            searchType: 'string',
          },
          width: 100,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Estimate Group',
          field: 'estimateGroupName',
          headerTooltip: 'Estimate Group',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
      ]
    },

    getEstimates() {
      this.loader = true
      instance
        .get(
          projectAPIs.project.asset.estimate.list(
            this.$route.params.id,
            this.projectData.assetId,
          ),
        )
        .then(response => {
          this.panels = []
          const data = _.get(response.data, 'result', null)
          this.panels.push({
            id: data.id,
            estimateGroupName: data.estimateGroupName,
            isValidTakeoff: data.isValidTakeoff,
            costDetails: [],
          })
          if (data.estimateGroup && data.estimateGroup.length > 0) {
            data.estimateGroup.forEach(element => {
              const calculation = {
                area_Total_Building: _.get(element, 'areaTotalBuilding', 0),
                area_Building_Footprint: _.get(
                  element,
                  'areaBuildingFootprint',
                  0,
                ),
                number_Of_Stories: _.get(element, 'numberOfStories', 0),
                perimeter_Building_Footprint: _.get(
                  element,
                  'perimeterBuildingFootprint',
                  0,
                ),
                average_Story_Height: _.get(element, 'averageStoryHeight', 0),
                totalSiteArea: _.get(element, 'totalSiteArea', 0),
                numberOfBuilding: _.get(element, 'numberOfBuilding', 0),
              }
              if (element.estimateGroupName) {
                this.panels.push({
                  id: element.id,
                  projectId: element.projectId,
                  assetId: element.assetId,
                  estimateGroupName: element.estimateGroupName,
                  estimateMethod: element.estimateMethod,
                  colorCode: element.colorCode,
                  Sequence: element.Sequence,
                  calculation: calculation,
                  isValidTakeoff: element.isValidTakeoff,
                  costDetails: [],
                  takeoffs: [],
                })
              }
            })
          }
          this.activeKey = 0
          this.activeTab = this.panels[0].id
          this.loader = false
          this.getTakeoffs(this.panels[0].id)
          this.$emit(
            'checkEstimateGroups',
            this.panels.filter(i => i.id > 0).length,
          )
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    getTakeoffs(id) {
      this.isDelete = false
      this.loader = true
      instance
        .get(
          projectAPIs.project.asset.estimate.details(
            this.$route.params.id,
            this.projectData.assetId,
            id,
          ),
        )
        .then(response => {
          const index = this.panels.findIndex(i => i.id === id)
          if (index > -1) {
            let isValidTakeoff = true
            const takeoffs = [
              ..._.get(
                response.data,
                'result.takeoffs',
                [],
              ),
              ..._.get(
                response.data,
                'result.costDetails',
                [],
              ),
            ]
            if (id > 0) {
              this.panels[index].takeoffs = _.get(
                response.data,
                'result.takeoffs',
                [],
              )
              this.panels[index].costDetails = _.get(
                response.data,
                'result.costDetails',
                [],
              )
              isValidTakeoff = takeoffs.some(
                i =>
                  typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
              )
              if (isValidTakeoff) {
                this.panels[index].isValidTakeoff = !isValidTakeoff
              }
            } else if (id === 0) {
              const costDetails = []
              _.get(response.data, 'result.costDetails', []).forEach(
                element => {
                  element.estimatedMethod =
                    element.estimateMethod === 1
                      ? 'Variance'
                      : element.estimateMethod === 2
                        ? 'Residual'
                        : undefined
                  costDetails.push(element)
                },
              )
              this.panels[index].costDetails = costDetails
            }
          }
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    onTabChange(value) {
      this.activeKey = value
      this.activeTab = this.panels[value].id
      this.getTakeoffs(this.activeTab)
    },

    createGroup(request) {
      instance
        .post(
          projectAPIs.project.asset.estimate.add(
            this.$route.params.id,
            this.projectData.assetId,
          ),
          request,
        )
        .then(response => {
          const data = _.get(response.data, 'result', null)
          const isPresent = this.panels.find(i => i.id === data.id)
          if (!isPresent) {
            const calculation = {
              area_Total_Building: _.get(data, 'areaTotalBuilding', 0),
              area_Building_Footprint: _.get(data, 'areaBuildingFootprint', 0),
              number_Of_Stories: _.get(data, 'numberOfStories', 0),
              perimeter_Building_Footprint: _.get(
                data,
                'perimeterBuildingFootprint',
                0,
              ),
              average_Story_Height: _.get(data, 'averageStoryHeight', 0),
              totalSiteArea: _.get(data, 'totalSiteArea', 0),
              numberOfBuilding: _.get(data, 'numberOfBuilding', 0),
            }
            this.panels.push({
              id: data.id,
              projectId: data.projectId,
              assetId: data.assetId,
              estimateGroupName: data.estimateGroupName,
              estimateMethod: data.estimateMethod,
              colorCode: data.colorCode,
              Sequence: data.Sequence,
              calculation: calculation,
              isValidTakeoff: data.isValidTakeoff,
              costDetails: [],
              takeoffs: [],
            })
          }
          if (request.id === 0) {
            this.$root.$emit('hideLoader', false)
          }
          if (request.costDetailsIds && request.costDetailsIds.length > 0) {
            const index = this.panels.findIndex(i => i.id === 0)
            const costDetails = [...this.panels[index].costDetails]
            costDetails.forEach(element => {
              const costDetail = request.costDetailsIds.find(
                i => i === element.id,
              )
              if (costDetail) {
                element.estimateGroupId = data.id
                element.estimateGroupName = data.estimateGroupName
                element.estimatedMethod =
                  data.estimateMethod === 1
                    ? 'Variance'
                    : data.estimateMethod === 2
                      ? 'Residual'
                      : undefined
              }
            })
            this.panels[index].costDetails = [...costDetails]
          }
          const groups = [...this.panels]
          this.$emit(
            'checkEstimateGroups',
            groups.filter(i => i.id > 0).length,
          )
        })
        .catch(error => {
          if (request.id === 0) {
            this.$root.$emit('hideLoader', false)
          }
          this.loader = false
          this.$root.$emit('popupUpdation', false, true, null)
          errorService(error)
        })
    },

    showEstimateGroups() {
      this.visible = true
    },

    onClose(record, ids, type) {
      let index
      switch (type) {
        case 'update':
          index = this.panels.findIndex(i => i.id === record.id)
          this.panels[index].estimateGroupName = record.estimateGroupName
          if (this.activeKey === 0) {
            this.getTakeoffs(this.activeTab)
          }
          break
        case 'delete':
          ids.forEach(element => {
            index = this.panels.findIndex(i => i.id === element)
            this.panels.splice(index, 1)
          })
          const isDeleted = ids.some(i => i === this.activeTab)
          if (this.activeKey === 0 || isDeleted) {
            this.onTabChange(0)
          }
          this.$emit(
            'checkEstimateGroups',
            this.panels.filter(i => i.id > 0).length,
          )
          break
        case 'sequence':
          this.loader = true
          this.getEstimates()
          break
        case 'error':
          index = this.panels.findIndex(i => i.id === record.id)
          this.panels[index].estimateGroupName = record.estimateGroupName
          break
        default:
          this.visible = false
          break
      }
    },

    updateMethod(value) {
      this.estimateMethod = value
    },

    deleteCostDetails() {
      this.isDelete = true
      this.getTakeoffs(this.activeTab)
    },

    resetData(data) {
      const newData = [...this.panels]
      const index = newData.findIndex(i => i.id === data.id)
      if (index > -1) {
        newData[index].estimateGroupName = data.estimateGroupName
      }
      this.panels = [...newData]
    },

    checkValidTab(id, isValid) {
      const index = this.panels.findIndex(i => i.id === id)
      if (index > -1) {
        this.panels[index].isValidTakeoff = isValid
      }
    },

    // Socket Section Start //
    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.projectSidebarUpdated) {
        this.$root.$emit('projectSideBarUpdated', message)
      }
      if (checkEvents(data.EventType)) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.analysisSheetUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
        this.$root.$emit(`bankTakeoffs${this.projectData.assetId}`)
      } else if (
        data.EventType === socketEvents.estimateTakeoffTrendedCostUpdated
      ) {
        this.$root.$emit('popupUpdation', false, true, null)
        if (data.Result && data.Result.length > 0) {
          const group = data.Result.find(i => i.EstimateMethodUpdated)
          if (group) {
            const index = this.panels.findIndex(
              i => i.id !== 0 && i.id === group.Id,
            )
            if (index > -1) {
              this.panels[index].estimateMethod = this.estimateMethod
            }
            this.estimateMethod = undefined
            this.getTakeoffs(group.Id)
          } else if (this.isDelete) {
            this.getTakeoffs(this.activeTab)
          }
        }
      } else if (data.EventType === socketEvents.buildingGeneralUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.error) {
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification('error', 'Socket', data.Result)
      }
    },
    // Socket Section End //
  },
}
